import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './index.scss';
import LeadsDashboard from '../../BarChartWithCards';
import backicon from './../../../../../Assets/icons/backIcon.svg'
import { Modal } from 'react-bootstrap';
import TotalCounts from '../../TotalCounts';

const OldLeadCallingDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get('id');

  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [selectedAssignee, setSelectedAssignee] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [showRemarkModal, setShowRemarkModal] = useState(false); // Add state for remark modal
  const [remark, setRemark] = useState(''); // Add state for remark
  const [assigneeList] = useState([
    { name: 'Telecaller 1', assignedLeads: 5 },
    { name: 'Telecaller 2', assignedLeads: 10 },
    { name: 'Telecaller 3', assignedLeads: 3 },
    { name: 'Sales Manager 1', assignedLeads: 8 },
    { name: 'Sales Manager 2', assignedLeads: 6 },
    { name: 'Sales Manager 3', assignedLeads: 2 },
  ]);

  const [filteredAssigneeList, setFilteredAssigneeList] = useState(assigneeList);
  const data = {
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
    organicLeads: [15, 20, 30, 40, 25, 30, 20],
    socialMediaLeads: [10, 15, 25, 35, 20, 25, 15],
    adsLeads: [5, 10, 15, 20, 10, 15, 10],
    otherLeads: [3, 5, 8, 12, 6, 8, 5],
  };

  const handleSearchChange = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);
    const filteredList = assigneeList.filter(assignee =>
      assignee.name.toLowerCase().includes(value)
    );
    setFilteredAssigneeList(filteredList);
  };

  const handleAssignClick = (type) => {
    setModalType(type);
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedAssignee('');
  };

  const handleAssigneeChange = (event) => {
    setSelectedAssignee(event.target.value);
  };

  const handleAssign = () => {
    console.log(`Assigning ${modalType} to ${selectedAssignee}`);
    // Implement your assignment logic here
    setShowModal(false);
  };

  const handleOpenModal = (type) => {
    setModalType(type);
    setShowModal(true);
  };

  const handleOpenRemarkModal = () => {
    setShowRemarkModal(true);
  };

  const handleCloseRemarkModal = () => {
    setShowRemarkModal(false);
  };

  const handleSaveRemark = () => {
    console.log('Remark:', remark);
    // Implement your logic to save the remark here
    setShowRemarkModal(false);
  };

  const assigneeTypeFilter = modalType === 'Telecaller' ? 'Telecaller' : 'Sales Manager';
  const filteredAssignees = assigneeList.filter(assignee => assignee.name.includes(assigneeTypeFilter));

  return (
    <div>
      <div className='OnboardManagamentContainer row'>
        <TotalCounts />
        {/* <div className='OnboardManagamentbuttonContainer col-xl-6 col-lg-12 mt-2 mb-2'>
          <h5>Todays FollowUp</h5>
        </div>
        <div className='totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2'>
          <div className='totalvalues'>
            <h5>50</h5>
            <h6>Total Leads</h6>
          </div>
          <div className='totalvalues'>
            <h5>30</h5>
            <h6>New Leads</h6>
          </div>
          <div className='totalvalues'>
            <h5>20</h5>
            <h6>Follow-Up Leads</h6>
          </div>
          <div className='totalvalues'>
            <h5>20</h5>
            <h6>Closed Leads</h6>
          </div>
          <div>
            <button className='addcustomerbutton' onClick={() => navigate('/admin/manage-dealer/business-partner/add-business-partner')}>
              Add Lead
            </button>
          </div>
        </div> */}
      </div>

      {/* <div>
        <LeadsDashboard data={data} />
      </div> */}

      <div className="details-container">
      <div className="backbutton mt-2 mb-2">
        <img src={backicon} alt="back" />
        <span className="backbtntitle">Lead Calling</span>
      </div>
        
         
         
       
        
        <div className="details-section">
        <h5 className='mt-2 mb-2'>Call Details</h5>
          <h5>Follow-up Details</h5>
          <div className="details-grid">
            <div className="details-item">
              <span className="details-label">Tele Caller Name:</span>
              <span className="details-value">Telecaller1</span>
              <span className="details-value">Telecaller1</span>
            </div>
            <div className="details-item">
              <span className="details-label">Sales Manager :</span>
              <span className="details-value">Balaji Kokate</span>
              <span className="details-value">Ashok Nayar</span>
            </div>
            <div className="details-item">
              <span className="details-label">Follow Up Date:</span>
              <span className="details-value">2024-07-01</span>
              <span className="details-value">2024-07-02</span>
            </div>
            <div className="details-item">
              <span className="details-label">Stage:</span>
              <span className="details-value">Stage1</span>
              <span className="details-value">Stage2</span>
            </div>
            <div className="details-item">
              <span className="details-label">Lead Status:</span>
              <span className="details-value">In Progress</span>
              <span className="details-value">Active</span>
            </div>
            <div className="details-item">
              <span className="details-label">Remark:</span>
              <span className="details-value">Call me Later</span>
              
            </div>
            <button className='action-button mt-2' onClick={handleOpenRemarkModal}>Add Remark</button> 
          </div>
        </div>
        <div className="details-actions">
          <button className='action-button' onClick={() => handleAssignClick('Telecaller')}>Assign Telecaller</button>
          <button className='action-button' onClick={() => handleAssignClick('Sales Manager')}>Assign Sales Manager</button>
          <button className='action-button ' onClick={() => console.log('Call Now')}>Call Now</button>
         
        </div>
      </div>

      {showModal && (
        <Modal isPresales={true} show={showModal} onHide={handleModalClose} centered>
          <span className='modalheading'>Select {modalType}</span>
          <input
            type="text"
            placeholder="Search"
            className="leadmodalsearch mt-2 mb-2"
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <div className="assignee-list">
            {filteredAssignees.map((assignee, index) => (
              <div key={index} className="assignee-item mt-2">
                <label htmlFor={`assignee-${index}`}>{assignee.name}</label>
                <div className='countcontainer'>
                  <label htmlFor={`assignee-${index}`} className='counttotal'> {assignee.assignedLeads} leads Assigned</label>
                  <input
                    type="radio"
                    id={`assignee-${index}`}
                    name="assignee"
                    value={assignee.name}
                    onChange={handleAssigneeChange}
                    checked={selectedAssignee === assignee.name}
                  />
                </div>
              </div>
            ))}
          </div>
          <div className='modalbuttons mt-2 mb-2'>
            <button onClick={handleModalClose} className='leadbtn'>Cancel</button>
            <button onClick={handleAssign} className='leadbtn'>Assign </button>
          </div>
        </Modal>
      )}

      {showRemarkModal && (
        <Modal show={showRemarkModal} onHide={handleCloseRemarkModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>Add Remark</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <textarea
              rows="4"
              className="form-control"
              placeholder="Enter your remark here..."
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
            />
          </Modal.Body>
          <Modal.Footer>
            <button className='btn btn-secondary' onClick={handleCloseRemarkModal}>Cancel</button>
            <button className='btn btn-primary' onClick={handleSaveRemark}>Save Remark</button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default OldLeadCallingDetails;
